import * as React from 'react';
import { useParams } from 'react-router';
import { OrderDetailPageContainer } from './containers';

interface RouterParams {
    uuid: string;
}

const OrderDetailPageRoute: React.FC = () => {
    const { uuid } = useParams<RouterParams>();
    return <OrderDetailPageContainer uuid={uuid} />;
};

export default OrderDetailPageRoute;
